import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { COMPANY_NAME, COMPANY_CONTACT } from "../../config/constants";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const navigationLinks = [
    { href: "#about", translationKey: "nav.about" },
    { href: "#services", translationKey: "nav.services" },
    { href: "#fleet", translationKey: "nav.fleet" },
    { href: "#contact", translationKey: "nav.contact" },
  ];

  return (
    <footer className="bg-dark text-white py-12 border-t border-neutral app-container">
      <div className="mx-auto px-4 flex flex-col gap-16">
        <div className="max-w-[400px] mx-auto">
          <h3 className="text-xl font-bold mb-4 text-center">{COMPANY_NAME}</h3>
          <p className="text-white text-center">{t("footer.description")}</p>
        </div>
        <div className="flex justify-center gap-20 flex-wrap">
          {/* Contact */}
          <div className="flex flex-col justify-center text-center md:text-left">
            <h3 className="text-xl font-bold mb-4">
              {t("footer.contact.title")}
            </h3>
            <ul className="space-y-2 text-white">
              <li>{COMPANY_CONTACT.phone}</li>
              <li>{COMPANY_CONTACT.email}</li>
              <li>{COMPANY_CONTACT.address}</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col justify-center text-center md:text-left">
            <h3 className="text-xl font-bold mb-4">
              {t("footer.quickLinks.title")}
            </h3>
            <ul className="space-y-2">
              {navigationLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-white hover:text-primary transition-colors"
                  >
                    {t(link.translationKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-12 text-center">
          <p>
            &copy; {new Date().getFullYear()} {COMPANY_NAME}.{" "}
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
